import React, { useEffect, useState } from "react";

import {
  Row,
  Col,
  Modal,
  Input,
  Button,
  Container, 
  ModalBody,
  ModalHeader,
  Label,
} from "reactstrap";
import { get } from "lodash";
import { toast, ToastContainer } from "react-toastify";
import success from "../../../src/waitlistDocVault/assets/images/success.png";
import failure from "../../../src/waitlistDocVault/assets/images/failure.png";
import uploadimage from "../../../src/waitlistDocVault/assets/images/uploadimage.png";

import {
  uploadDoc,
  getThirdPartyData,
  getUploadedDocsList,
  updateThirdPartyData,
} from "../../waitlist/services/waitlist-service";
import { onboardingService } from "../../shell/services/onboarding";
import AddressPreview from "./AddressPreview";
import { countryList, stateList } from '../assets/constants/stateCountryList';
import { utils } from "../../core/helpers/utils";
// import { Mixpanel } from "../../waitlist/components/MixPanel";
import { setAnalyticsEvent } from "../../core/helpers/analytics";

export default function KycAdressContentNew(props) {
  const { email, setReupload, areAllDocsUploaded, updateDocStatus, uploadedDocs } = props;
  const [pan, setPan] = useState(props.pan);
  const [userProfile, setUserProfile] = useState(() => {
    return props.userProfile;
  });
  const [modalMessage, setModalMessage] = useState("");
  const [uploadedAdress, setUploadedAdress] = useState([]);
  const [adressPresent, setAdressPresent] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [docSide, setDocSide] = useState(null);
  const [isDocFrontUploaded, setIsDocFrontUploaded] = useState(false);
  const [isDocBackUploaded, setIsDocBackUploaded] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [addressFile, setAddressFile] = useState([]);
  const [product, setProduct] = useState(props?.product);
  const [isPanUploaded, setIsPanUploaded] = useState(false);
  const [address, setAddress] = useState(null);
  const [area, setArea] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [country, setCountry] = useState("India");
  const [pincode, setPincode] = useState(null);
  const [isAddressBackErr, setAddressBackErr] = useState(false);
  const [errorStr, setErrorStr] = useState(false);
  const [enableStateDropdown, setEnableStateDropdown] = useState(false);

  useEffect(() => {
    setPan(props.pan);
  }, [props.pan]);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    let mobile = window.matchMedia("(max-width: 768px").matches;
    setIsMobile(mobile);
    getUserProfile();
  }, []);

  const getUserDocsList = (pan) => {
    onboardingService.getOnboardingUserDocState({ pan: pan }).then((result) => {
      const res = utils.parsePayload(result);
      if (res && res.success) {
        let addressDocs = get(res, "data", []).filter(
          (d) => d.type === "address" || d.type === "address_1"
        );
        if (addressDocs.length) {
          setAdressPresent(true);
          setUploadedAdress(addressDocs);
        }
        areAllDocsUploaded && areAllDocsUploaded(get(res, "data", []));
      }
    });
  };

  const getUserProfile = () => {
    if (userProfile && userProfile.pan) {
      setPan(userProfile.pan);
      getUserDocsList(userProfile.pan);
    } else {
      setPan(pan);
      getUserDocsList(pan);
    }
  };

  const ifDocsUploaded = () => {
    if (uploadedDocs.find(e => e.type === 'pan') &&
    uploadedDocs.find(e => e.type === 'address'))
        {
          return true;
        } else return false;
      }

  const readFileAsBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        resolve(event.target.result);
      };

      reader.onerror = (err) => {
        reject({
          message:
            "Unable to retrieve file data. Uploading files from Google drive is not working at this moment. Please select another option to upload files.",
        });
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const uploadDocument = (inputFile, docType) => {
    readFileAsBuffer(inputFile)
      .then(async (bufferedFile) => {
        const clonedFile = new File([bufferedFile], inputFile.name, {
          type: inputFile.type,
        });

        //Try to read if file is present or not by reading only first byte of file
        await clonedFile
          .slice(0, 1)
          .arrayBuffer()
          .then(() => {
            let type = docType === "pan" ? "pan" : "address";
            let temptype = docType === "address" ? "front" : "back";

            if (docType !== "pan") {
              type = type + ' ' + temptype;
            } else {
              type = "pan";
              temptype = "pan";
            }            

            let docsPan = pan
              ? pan
              : props.userProfile && props.userProfile.pan
              ? props.userProfile.pan
              : props.thirdpartyData?.data?.pan
              ? props.thirdpartyData.data.pan
              : null;

            uploadDoc(
              email, 
              docsPan, 
              clonedFile, 
              docType, 
              {"X-product": `orobonds:default`}
            ).then(
              (res) => {
                if (res && !res.success) {
                  setModalMessage("Your " + type + " is not uploaded");
                  setShowSuccessModal(true);
                  setReupload(true);
                  return toast.error(res.error);
                }

                if (res && res.success) {
                  setModalMessage("Your " + type + " is successfully uploaded");                  
                  if (docType !== "pan") {
                    setDocSide(temptype);
                    updateThirdPartyData(utils.encryptedPayload({
                      [docType]: 'XXXX',
                      addressDocType: docType,
                      productName: 'oroBonds'
                    }), {"X-product": `orobonds:default`, 'x-encrypted-data': true}).then((response) => {
                      if (response && response.success) {
                        // setUserProfile({
                        //   ...userProfile,
                        //   ...get(response, "data.thirdPartyData", {}),
                        // });
                        setShowSuccessModal(true);
                        setReupload(true);
                        if (docType === "address") {
                          setIsDocFrontUploaded(true);
                        } else if (docType === "address_1") {
                          setAddressBackErr(false);
                          setIsDocBackUploaded(true);
                        }
                      }
                    });
                  } else {
                    setIsPanUploaded(true);
                    setShowSuccessModal(true);
                    setReupload(true);
                  }          
                }
              },
              (err) => {
                setModalMessage("Your " + type + " is not successfully uploaded");
                setShowSuccessModal(true);
              }
            );
          })
          .catch(() => {
            return toast.error(
              "Unable to retrieve file data. Please select another option to upload the document"
            );
          });
      })
      .catch((err) => {
        return toast.error(
          err.message ||
            "Unable to retrieve file data. Please select another option to upload the document",
          { autoClose: 6500 }
        );
      });
  };

  useEffect(() => {
    if (showSuccessModal) {
      updateDocStatus();
      getUserDocsList(userProfile && userProfile?.pan || pan);
      setTimeout(() => {
        setShowSuccessModal(false);
      }, 2000);    
    }
  }, [isPanUploaded, isDocFrontUploaded, isDocBackUploaded, showSuccessModal]);

  const toggleSuccess = () => {
    setShowSuccessModal(false);
    if (docSide === "back") {
      getUserDocsList(userProfile && userProfile?.pan || pan);
      props.moveNextTab();
    }
  };

  const moveNextTab = () => {
    /* Mixpanel.track("cl_next_kyc_address_docvault",
      {
        "Email id": email ? email : ""
      }
    ); */
    if (!address || !area || !city || !state || !country || !pincode) {
      setErrorStr(true);
      return;
    }
    if (checkDocUploadStatus('address') === 'Upload' ||
    checkDocUploadStatus('pan') === 'Upload' || isAddressBackErr) {
      toast.error("Please upload required documents");
      return;
    }
    let addressDetails = {};
    addressDetails.address = address;
    addressDetails.state = state;
    addressDetails.districtOrCity = city;
    addressDetails.pincode = pincode;
    addressDetails.localityOrPostOffice = area;
    addressDetails.country = country;
    updateThirdPartyData(utils.encryptedPayload({ addressDetails }), { "X-product": `orobonds:default`, 'x-encrypted-data': true })
    .then(() => {
      setAnalyticsEvent("SIkycAddressverified");
    })
    .catch((error) => {
      // Handle any errors that occur during the updateThirdPartyData operation.
      console.log("Error:", error);
    });
    getUserDocsList(userProfile && userProfile?.pan || pan);
    props.moveNextTab();
  };

  const previewAddress = () => {
    // Get the docs from /getUserDocsWithPan
    // Filter address related docs
    // set the docs so that address modal can open/show
    // getUploadedDocsList(userProfile?.pan || pan).then((docsList) => {
    
    if (uploadedDocs.length) {
      let filename = uploadedDocs.filter(e => e.type === 'pan' ||
        e.type === 'poi' ||  e.type === 'address' || e.type === 'address_1');
      setAddressFile([...filename]);
    }
  }

  useEffect(() => {
    if (addressFile && addressFile.length) {
      setIsPreview(true);
    }
  }, [addressFile]);

  useEffect(() => {
    if (props.errors.length &&
      props.errors.find(e => e.type === 'address_1')) {      
      setAddressBackErr(true);
    } else {
      setAddressBackErr(false);
    }
  }, [props.errors])

  const updateAddress = (type, value) => {
    setErrorStr(false);
    switch (type) {
      case "address": 
        setAddress(value);
        break;
      case "area":
        setArea(value);
        break;
      case "city":
        setCity(value);
        break;
      case "state":
        setState(value);
        break;
      case "country":
        setCountry(value);
        if (value.trim().toLowerCase() === 'india') {
          setState('');
          setEnableStateDropdown(true);
        } else {
          setState('');
          setEnableStateDropdown(false);
        }
        break;
      case "pincode":        
        setPincode(value);
        break;
    }
  }

  const checkNumberPattern =(e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  }

  const checkAlphabetPattern =(e) => {
    if (!/^[a-zA-Z ]+$/.test(e.key)) {
      e.preventDefault();
    }
  }

  const filterNumericPaste = (e) => {
    const text = e.clipboardData.getData('Text');
    if (!/^[a-zA-Z ]+$/.test(text)) {
      e.preventDefault();
      return;
    }
  }

  const onPasteTrigger = (e) => {
    const num = e.clipboardData.getData('Text');
    if (!/^[0-9]+$/.test(num)) {
      e.preventDefault();
      return;
    }     
  }

  const prefillAddressDetails = () => {
    if (userProfile && userProfile.addressDetails &&
      Object.keys(userProfile.addressDetails).length) {
        setAddress(userProfile.addressDetails.address);
        setCity(userProfile.addressDetails.districtOrCity);
        setArea(userProfile.addressDetails.localityOrPostOffice);
        setCountry(userProfile.addressDetails.country);
        setState(userProfile.addressDetails.state);
        setPincode(userProfile.addressDetails.pincode);
      }
  }

  useEffect(() => {
    prefillAddressDetails();
  }, [userProfile]);

  const checkDocUploadStatus = (type) => {
    if (uploadedDocs.find(e => (type === 'pan') ?
    (e.type === 'pan' || e.type === 'poi') : e.type === type)) { //if doc is uploaded
      if (props.errors.length && props.errors.find(e =>
        (type === 'pan') ?
        (e.type === 'pan' || e.type === 'poi') : e.type === type)) { // and it is rejected
        return 'Upload';
      }
      return 'Reupload';
    }
    return 'Upload';
  }

  useEffect(() => {
    if (country.toLowerCase() === 'india') {
      setEnableStateDropdown(true);
    } else {
      setEnableStateDropdown(false);
    }
  }, [country]);

  return (
    <>
      <div className="kyc-content-block address-ip-main">
        <Container className="form-container justify-content-center" 
                   style= {!isMobile ? {"width" : "420px",
                          "padding" : "2rem"} : {}}
        >
          <Row>
            <Col>
              <div
                className={
                  "justify-content-center " + !isMobile
                    ? "adress-banner"
                    : "adress-banner-mob"
                }
              >
                <h5 style={{ color: "black" }}>
                  <strong className="text-capitalize">Verify your KYC</strong>
                </h5>
                <div className="address-ip-container input-group">
                  <div className="each-detail-ip">
                    <Label className={address ? "font-size-tiny text-muted" : "d-none"}>
                        Address
                    </Label>
                    <Input
                      type="text"
                      name="address-line-1"
                      className="address-input-field"
                      value={address}
                      onChange={(e) => updateAddress("address", e.target.value)}
                      placeholder="Address *"
                      maxLength="150"
                    />
                    <Label className={"text-danger font-size-tiny " +
                      ((!address && errorStr) ? "d-block" : "d-none")}>
                      Enter Address
                    </Label>
                  </div>
                  <div className="each-detail-ip">
                    <Label className={area ? "font-size-tiny text-muted" : "d-none"}>
                      Locality or Post Office
                    </Label>
                    <Input
                      type="text"
                      name="area"
                      className="address-input-field"
                      value={area}
                      onChange={(e) => updateAddress("area", e.target.value)}
                      placeholder="Locality or Post Office *"
                    />
                    <Label className={"text-danger font-size-tiny " +
                      ((!area && errorStr) ? "d-block" : "d-none")}>
                      Enter Locality or Post Office
                    </Label>
                  </div>
                  <div className="each-detail-ip">
                    <Label className={city ? "font-size-tiny text-muted" : "d-none"}>
                      City
                    </Label>
                    <Input
                      type="text"
                      name="city"
                      className="address-input-field"
                      value={city}
                      onChange={(e) => updateAddress("city", e.target.value)}
                      placeholder="City *"
                      onKeyPress={(e) => checkAlphabetPattern(e)}
                      onPaste={(e) => filterNumericPaste(e)}
                    />
                    <Label className={"text-danger font-size-tiny " +
                      ((!city && errorStr) ? "d-block" : "d-none")}>
                      Enter City
                    </Label>
                  </div>
                  <div className="each-detail-ip">
                    <Label className="font-size-tiny text-muted">
                      State
                    </Label>
                    {!enableStateDropdown ? 
                      <Input
                        type="text"
                        name="state"
                        className="address-input-field"
                        value={state}
                        onChange={(e) => updateAddress("state", e.target.value)}
                        placeholder="State *"
                        onKeyPress={(e) => checkAlphabetPattern(e)}
                        onPaste={(e) => filterNumericPaste(e)}
                      /> :
                      <select
                        className="oro-dropdown" 
                        value={state && state.toLowerCase()}
                        onChange={(e) => updateAddress("state", e.target.value)}
                      >
                        {(!userProfile || !userProfile.addressDetails ||
                        !userProfile.addressDetails.state || !state) &&
                        <option
                          value=""
                          selected
                          disabled>Select State</option>}
                        {stateList.map(item => 
                          <option value={item.toLowerCase()}>
                            {utils.convertToCapitalize(item)}
                          </option>  
                        )}
                      </select>}
                    <Label className={"text-danger font-size-tiny " +
                      ((!state && errorStr) ? "d-block" : "d-none")}>
                      Enter State
                    </Label>
                  </div>
                  <div className="each-detail-ip">
                    <Label className={country ? "font-size-tiny text-muted" : "d-none"}>
                      Country
                    </Label>
                    <select
                      value={country.toLowerCase()}
                      onChange={(e) => updateAddress('country', e.target.value)}
                      className="oro-dropdown" 
                    >
                      {countryList.map(item => 
                        <option value={item.toLowerCase()}>
                          {utils.convertToCapitalize(item)}
                        </option>
                      )}
                    </select>
                    <Label className={"text-danger font-size-tiny " +
                      ((!country && errorStr) ? "d-block" : "d-none")}>
                      Enter Country
                    </Label>
                  </div>
                  <div className="each-detail-ip">
                    <Label className={pincode ? "font-size-tiny text-muted" : "d-none"}>
                      Pin Code
                    </Label>
                    <Input
                      type="text"
                      name="pincode"
                      className="address-input-field"
                      value={pincode}
                      onChange={(e) => updateAddress("pincode", e.target.value)}
                      placeholder="Pin Code *"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      onKeyPress={(e) => checkNumberPattern(e)}
                      maxLength="6"
                      onPaste={(e) => onPasteTrigger(e)}
                    />
                    <Label className={"text-danger font-size-tiny " +
                      ((!pincode && errorStr) ? "d-block" : "d-none")}>
                      Enter Pin Code
                    </Label>
                  </div>
                </div>
                <div className="upload-container">
                {/* Upload Document Front */}
                  <div 
                    className="upload-front mt-3"
                  >
                    <label>
                      <img
                        className="mt-4"
                        alt="success-icon"
                        src={checkDocUploadStatus('pan') === 'Upload' ?
                        uploadimage : success}
                      />

                      <h6 className="text-muted mt-4">
                      {checkDocUploadStatus('pan') +
                        " your PAN"}
                        <span>*</span>
                      </h6>

                      <input
                        type="file"
                        id="upload"
                        name="pan"
                        className="doc-input"
                        style={{ display: "none" }}
                        onClick={(e) => (e.target.value = "")}
                        accept=".png, .pdf, .jpg, .jpeg"
                        onChange={(e) =>
                          uploadDocument(e.target.files[0], "pan")
                        }
                      />
                    </label>
                  </div>
                  <div className="upload-front mt-3">
                    <label>
                      <img
                        alt="success"
                        className="mt-4"
                        src={checkDocUploadStatus('address') === 'Upload' ?
                        uploadimage : success}
                      />

                      <h6 className="text-muted mt-4">
                        {checkDocUploadStatus('address') +
                        " front side of your address proof"}
                        <span>*</span>
                      </h6>

                      <input
                        type="file"
                        id="upload"
                        name="docnumber"
                        className="doc-input"
                        style={{ display: "none" }}
                        onClick={(e) => (e.target.value = "")}
                        accept=".png, .pdf, .jpg, .jpeg"
                        onChange={(e) =>
                          uploadDocument(e.target.files[0], "address")
                        }
                      />
                    </label>
                  </div>

                  {/* Upload Document Back */}
                  <div className="upload-front mt-3">
                    <label>
                      <img 
                        alt="success"
                        className="mt-4"
                        src={checkDocUploadStatus('address_1') === 'Upload' ?
                        uploadimage : success}
                      />

                      <h6 className="text-muted mt-4">
                        {checkDocUploadStatus('address_1') +
                        " back side of your address proof"}
                      </h6>

                      <input
                        type="file"
                        id="upload"
                        name="docnumber"
                        className="doc-input"
                        style={{ display: "none" }}
                        onClick={(e) => (e.target.value = "")}
                        accept=".png, .pdf, .jpg, .jpeg"
                        onChange={(e) =>
                          uploadDocument(e.target.files[0], "address_1")
                        }
                      />
                    </label>
                  </div>
                </div>
                {/* Next & Preview Buttons */}
                <div 
                  className="d-flex justify-content-between m-auto btn-div"
                  style={{maxWidth: 'max-content'}}
                >
                  <Button
                    color="#22c979"
                    className="m-4"
                    onClick={moveNextTab}
                  >
                    Next
                  </Button>

                  {ifDocsUploaded() ?
                    <Button
                      className="preview-btn m-4"
                      onClick={previewAddress}
                    >
                      Preview
                    </Button>
                  :
                    null
                  }
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {showSuccessModal && (
        <Modal centered isOpen={showSuccessModal} toggle={toggleSuccess}>
          <ModalHeader className="close-button" toggle={toggleSuccess}>
          </ModalHeader>
          <ModalBody style={{ margin: "0.5rem" }}>
            <div>
              <div className="pb-3">
                <img
                  style={{
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  src={
                    modalMessage.indexOf("successfully") !== -1
                      ? success
                      : failure
                  }
                  alt="img"
                ></img>
              </div>
              <p
                style={{ fontSize: "24px" }}
                className="text-center pt-2 font-weight-bold"
              >
                {modalMessage}
              </p>
            </div>
          </ModalBody>
        </Modal>
      )}
      {isPreview ? <AddressPreview
        isOpen={isPreview}
        toggle={() => setIsPreview(false)}
        address={addressFile}
      /> : null}
      <ToastContainer />
    </>
  );
} 
